import axios from "axios"
import { APIURL } from "src/config/helpers/base"

export const setDataTagDatasets = (pageNum = 1, sort = '', search = '', rows = '10') => {
    return (dispatch) => {
        dispatch({ type: 'DATA_TAGS', payload: false })
        axios.get(`${APIURL}/one/Dataset/GetDatasetGroupsTag?Search=${search}&Rows=${rows}&PageNum=${pageNum}&Sort=${sort}`).then(res => {
            var data = res.data;
            dispatch({ type: 'DATA_TAGS', payload: data.Datasets })
            dispatch({ type: 'TOT_RESULT_TAGS', payload: data.TotResult })
        })
    }
}

export const setDataTagDatasetBySlug = (slug, rows = 10, pageNum = 1, sort = 1, search = '') => {
    return (dispatch) => {
        dispatch({ type: 'DATA_TAG_DATASETS', payload: false })
        axios.get(`${APIURL}/one/Dataset/GetDatasetsByTag?Slug=${slug}&Search=${search}&Rows=${rows}&PageNum=${pageNum}&Sort=${sort}`).then(res => {
            var data = res.data;
            setTimeout(() => {
                dispatch({ type: 'DATA_TAG_DATASETS', payload: data })
                dispatch({ type: 'TOT_RESULT_TAG_DATASETS', payload: data.TotResult })
            }, 2000);
        })
    }
}